import { Controller } from "@hotwired/stimulus"

// facilities--handle-bounds — keeps every range handle inside a window that is
// narrower than the rail it is drawn on.
//
// The asset's sensitivity dialog draws the whole 0..100 % rail, as the legacy
// app's did, but an operator may only set warning no lower than 10 % and alert
// no higher than 90 % (FacilitiesAssetRackeyeConfig::OPERATOR_SENSITIVITY_RANGE).
// The gem's sliders take one min/max for both the scale and the travel, so the
// rail keeps 0..100 and this controller stops the handles at the window.
//
// The listeners are on the WRAPPER, in the capture phase, so the value is
// clamped before the gem's own `input`/`change` actions on the input read it:
// its fill, bands and readouts then paint the clamped value, and a pushed
// handle is pushed to it. Nothing is moved on connect: the server already
// opens a stored value outside the window (a legacy 145) on its nearest end,
// and a value outside it at connect is a refusal echoing what the operator
// sent — the dialog shows the number that was refused until a handle moves.
//
//   data-controller="facilities--handle-bounds"
//   data-facilities--handle-bounds-min-value="10"
//   data-facilities--handle-bounds-max-value="90"
export default class extends Controller {
  static values = { min: Number, max: Number }

  connect() {
    // Both edges must be declared: a missing one would read as 0 and pin every
    // handle there, which is worse than leaving the rail unbounded.
    if (!this.hasMinValue || !this.hasMaxValue) return

    this._onInput = (event) => this._clampTarget(event.target)
    this.element.addEventListener("input", this._onInput, true)
    this.element.addEventListener("change", this._onInput, true)
  }

  disconnect() {
    if (!this._onInput) return

    this.element.removeEventListener("input", this._onInput, true)
    this.element.removeEventListener("change", this._onInput, true)
  }

  _clampTarget(input) {
    if (!(input instanceof HTMLInputElement) || input.type !== "range") return

    const value = Number(input.value)
    const clamped = Math.min(Math.max(value, this.minValue), this.maxValue)
    if (clamped !== value) input.value = String(clamped)
  }
}
